export enum RoomStatePromptType {
  moderatorBot = 'moderator_bot',
  openaiTranscription = 'openai_transcription',
}

// convenience data types as enums are a nightmare to work dynamically with in JS
export const RoomStatePromptTypeMap = {
  moderator_bot: RoomStatePromptType.moderatorBot,
  openai_transcription: RoomStatePromptType.openaiTranscription,
}

export const RoomStatePromptTypeReverseMap = {
  [RoomStatePromptType.moderatorBot]: 'moderator_bot',
  [RoomStatePromptType.openaiTranscription]: 'openai_transcription',
}

export const RoomStatePromptTypeList = [
  RoomStatePromptType.moderatorBot,
  RoomStatePromptType.openaiTranscription,
]

export const RoomStatePromptTypeNames = Object.keys(RoomStatePromptTypeMap)
